'use client';

import { Button } from '@mui/material';
import { CallToActionButton as CallToActionButtonType } from '@peerless/data-access/strapi';
import { getButtonColorConversion, isValidUrl } from '../utils';
import { RouterLink } from '@/navigation';

interface Props {
  callToAction: CallToActionButtonType;
}

export function CallToActionButton({ callToAction }: Props) {
  const { buttonLink, buttonText, buttonColor, buttonType } = callToAction;
  const target = isValidUrl(buttonLink) ? '_blank' : '_self';
  const formattedVariant = buttonType === 'Outlined' ? 'outlined' : 'contained';
  return (
    <Button
      fullWidth
      variant={formattedVariant}
      href={buttonLink ?? '/'}
      target={target}
      component={RouterLink}
      color={getButtonColorConversion(buttonColor)}
    >
      {buttonText}
    </Button>
  );
}
